module.exports = __webpack_public_path__ + "static/img/chart_switch_list.912d011.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chart_switch_list.png
// module id = b+Dq
// module chunks = 1